// ui/src/components/ResponseDisplay.tsx
import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import { ExternalLink } from "lucide-react";

interface ResponseDisplayProps {
  content: string;
  className?: string;
  isUserMessage?: boolean;
}

export const ResponseDisplay: React.FC<ResponseDisplayProps> = ({
  content,
  className = "",
  isUserMessage = false,
}) => {
  if (isUserMessage) {
    return <div className={`text-sm ${className}`}>{content}</div>;
  }

  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      rehypePlugins={[rehypeRaw]}
      components={{
        ol: ({ ...props }) => (
          <ol className="list-decimal ml-8 mb-4" {...props} />
        ),
        ul: ({ ...props }) => <ul className="list-disc ml-8 mb-4" {...props} />,
        li: ({ ...props }) => <li className="my-1" {...props} />,
        p: ({ ...props }) => <p className="mb-4" {...props} />,
        a: ({ ...props }) => (
          <a
            className="text-blue-500 underline inline-flex items-center gap-1"
            target="_blank"
            rel="noopener noreferrer"
            {...props}
          >
            {props.children}
            <ExternalLink className="h-3 w-3" />
          </a>
        ),
        table: ({ ...props }) => (
          <div className="mb-4 overflow-x-auto">
            <table className="w-full border-collapse text-sm" {...props} />
          </div>
        ),
        thead: ({ ...props }) => (
          <thead className="border-b border-border" {...props} />
        ),
        th: ({ ...props }) => (
          <th
            className="px-3 py-2 text-left font-semibold align-bottom"
            {...props}
          />
        ),
        td: ({ ...props }) => (
          <td
            className="px-3 py-2 border-b border-border align-top"
            {...props}
          />
        ),
      }}
      className={className}
    >
      {content}
    </ReactMarkdown>
  );
};
